export default __webpack_public_path__ + "static/media/green.19f99273.svg";